export default __webpack_public_path__ + "static/media/element_17.992bb0a4.jpg";